import { useFilterFieldsConfig } from './FilterFieldsConfigContext'
import { useFilterFieldsForm } from './FilterFieldsFormContext'
import { useFilterFieldsStyling } from './FilterFieldsStylingContext'
import type { FilterFieldsContextValue } from './useFilterFieldsContext.types'

export const useFilterFieldsContext = (): FilterFieldsContextValue => {
  return {
    config: useFilterFieldsConfig(),
    styling: useFilterFieldsStyling(),
    form: useFilterFieldsForm()
  }
}
